import { IPopover, usePopover } from '@gem/ui-kit';

import { REACTION_POPOVER_HIDE_DELAY } from 'APP/constants/animations';
import { useReactions } from 'APP/main/hooks/useReactions/useReactions';
import { IReactionItem } from 'APP/main/hooks/useReactions/useReactions.types';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

interface IReactionButtonPresenter {
  userReaction: IReactionItem | null;
  onClick(): void;
}

interface IUseReactionButtonPresenter {
  presenter: IReactionButtonPresenter;
  popover: IPopover<HTMLButtonElement>;
}

export const useReactionButtonPresenter = (message: ChatMessage): IUseReactionButtonPresenter => {
  const reactions = useReactions(message);
  const popover = usePopover<HTMLButtonElement>({ mouseOutTimeout: REACTION_POPOVER_HIDE_DELAY });

  const presenter: IReactionButtonPresenter = {
    get userReaction(): IReactionItem | null {
      return reactions.currentMyReaction;
    },

    onClick(): void {
      popover.close();

      if (reactions.currentMyReaction) {
        reactions.onClick(reactions.currentMyReaction.id);
      } else {
        reactions.onDefaultReactionClick();
      }
    },
  };

  return { popover, presenter };
};
